'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = require('decisiv-ui-utils');

// Design used em units for headers and text line-heights, but all of our units are in rem.
// This is a quick conversion util to help keep all our units in rem.

function em2rem(px, em) {
  return (0, _decisivUiUtils.px2rem)(px * em);
}

exports.default = em2rem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/utils/em2rem.js
// module id = 133
// module chunks = 2